module.exports = __webpack_public_path__ + "static/media/logo_regular_white.cff30d71.svg";